import {
  CoverageFeeProductMatchType,
  isCoverageFeeProduct,
  NO_COVERAGE_PRODUCT_IDS,
} from "./is-coverage-fee-product";

interface CheckIsRedoLineItem {
  sku?: string | null;
  vendor?: string | null;
  name?: string;
  title?: string;
}

export const isRedoLineItem = (
  lineItem: CheckIsRedoLineItem | undefined,
  redoCoverageProductIds: ReadonlySet<string> = NO_COVERAGE_PRODUCT_IDS,
) => {
  if (!lineItem) {
    return false;
  }
  const title = "title" in lineItem ? lineItem.title : lineItem.name;
  return isCoverageFeeProduct({
    product: { vendor: lineItem.vendor, sku: lineItem.sku, title },
    redoCoverageProductIds,
    matchType: CoverageFeeProductMatchType.REDO_AND_COMPETITORS,
  });
};
